$(document).ready(function () {
    if ($('.single_airline_container').length > 0) {
        $('.single_airline_container').hide();
        $('.single_airline_container').slice(0, 20).show(); //load only 20 lines
        $('.airlines_filter_row .filter_element').on('click', function () {
            $('#airlines_show_more').removeClass('disable_show_more');
            $('.airlines_filter_row .filter_element').removeClass('selected');
            $(this).addClass('selected');
            $('.single_airline_container').removeClass('airline_opened').hide();
            $('.airline_more_info').slideUp();
            if ($(this).attr('id') != 'airlines_filter_button') {
                $('[data-letter="' + $(this).text() + '"]').slice(0, 20).show();
                if ($('[data-letter="' + $(this).text() + '"]:not(:visible)').length < 1) {
                    $('#airlines_show_more').addClass('disable_show_more');
                };
            } else {
                $('.single_airline_container').slice(0, 20).show();
                $('#airlines_show_more').removeClass('disable_show_more');
            };
        });

        //search func
        $('#airlines_search_button').on('click', function () {
            $('.single_airline_container').removeClass('airline_opened').hide();
            $('.airline_more_info').slideUp();
            let inputValue = $("#airlines_search_input").val().toLowerCase();
            let airlineContainer = $(".single_airline_container");
            $.each(airlineContainer, function (index) {
                let current = airlineContainer[index];
                let airlineName = $(current).find(`.airline_row_top .airline_name_col .airline__name`).text().toLowerCase();
                if (airlineName.includes(inputValue)) {
                    $(current).show();
                }
            });
            $('#airlines_show_more').addClass('disable_show_more');
        });
        $('#airlines_show_more').removeClass('disable_show_more');

        $('.module__airlines form').submit(function(evt) {
            evt.preventDefault();
            $('#airlines_search_button').trigger('click');
        });
    }
    //mobile overlay
    let overlayOpen = false;
    $('#airlines_filter_col_mobile_btn').click(function () {
        $('#airlines_filter_col_letters').fadeIn(300);
        $('#airlines_filter_col_letters').click(function () {
            $('#airlines_filter_col_letters').fadeOut(300);
            $('body').css('overflow', 'initial');
            overlayOpen = false;
        });
        $('body').css('overflow', 'hidden');
        overlayOpen = true;
    });
    //show more
    $('#airlines_show_more').on('click', function () {
        if ($('.airlines_filter_row .selected').text().length > 1) {
            let showing = $('.single_airline_container:visible').length;
            $('.single_airline_container').slice(0, showing + 20).slideDown('slow');
            if ($('.single_airline_container:not(:visible)').length < 1) {
                $('#airlines_show_more').addClass('disable_show_more');
            };
        } else {
            let get_letter = $('.single_airline_container:visible').attr('data-letter');
            let showing = $('[data-letter="' + get_letter + '"]').length;
            $('[data-letter="' + get_letter + '"]').slice(0, showing + 20).slideDown('slow');
            if ($('[data-letter="' + get_letter + '"]:not(:visible)').length < 1) {
                $('#airlines_show_more').addClass('disable_show_more');
            };
        };
    });
    //expand single airline
    $('.single_airline_container .airline_row_top i').on('click', function () {
        $(this).closest('.single_airline_container').toggleClass('airline_opened').children('.airline_more_info').slideToggle();
    });
});